/* eslint-disable react-hooks/exhaustive-deps */
import React,{FC, useEffect, useState} from "react";
import { Dropdown, FormControl, OverlayTrigger, Tooltip } from "react-bootstrap";
import { getListTradePartner } from "../core/_request";
import useAxiosPrivate from "../../../../libs/useAxiosPrivate";
import { getISO2ByISO3, getNameByISO3 } from '../../../../libs/misc'
import { useAuth } from "../../../../modules/auth";

type TradePartnerDropdownProps = {
  onSelect: (econ:any) => void;
}

const TradePartnerDropdown:FC<TradePartnerDropdownProps> = ({
  onSelect
}) => {
  const axiosPrivate = useAxiosPrivate()
  const { currentUser } = useAuth();
  const reporterISO3User = currentUser?.economy;
  const [economies, setEconomies] = useState<Array<any> | null>([])
  const [selectedEcon, setSelectedEcon] = useState<string>(''); 

  useEffect(()=>{
    getListTradePartner(axiosPrivate, reporterISO3User)
      .then(res=>{
        const econs = res.data.data.rows
        setEconomies([
          'WLD',
          ...econs
        ])
        setSelectedEcon('WLD')
        onSelect('WLD')
      })
      .catch(e=>{
        console.error(e)
      })
  },[])

  const handleSelect = (econ:any) => { 
    onSelect(econ);
    setSelectedEcon(econ)
  }

  const dropdownItem = economies?.map((econ)=>{
    const iso2 = getISO2ByISO3(econ) || ''
    let flagIcon = (<i className="fa-solid fa-globe me-2"></i>);
    if(iso2) {
      flagIcon =  (<span className={`fi fi-${iso2?.toLowerCase()} me-2`}></span>)
    }
    return (
      <OverlayTrigger 
        key={econ.toLowerCase()} 
        placement="left" 
        overlay={<Tooltip id={`tooltip-${iso2}`}>{getNameByISO3(econ)}</Tooltip>} > 
        <Dropdown.Item role="menuitem" size="sm" onClick={()=>handleSelect(econ)}> 
          {flagIcon}
          {getNameByISO3(econ)} 
        </Dropdown.Item> 
      </OverlayTrigger>
    )
  })

  const flagIcon = getISO2ByISO3(selectedEcon)?
    (<span className={`fi fi-${getISO2ByISO3(selectedEcon)?.toLowerCase()} me-2`}></span>):
    (<i className="fa-solid fa-globe me-2"></i>);

  return (    
    <Dropdown className="">
      <Dropdown.Toggle variant="label-dropdown" id="" className="btn btn-sm btn-bold dropdown-toggle fw-normal text-start w-100" style={{
        display:'flex',
        justifyContent:'space-between',
        alignItems:'center',
      }}>
        {selectedEcon ? 
          ( 
            <div style={{
              whiteSpace: 'nowrap', 
              overflow: 'hidden', 
              textOverflow: 'clip',
              maxWidth:'200px'
            }}> 
              {flagIcon}
              {getNameByISO3(selectedEcon)} 
            </div> 
          ) : ('Loading Trade Partners...')}
      </Dropdown.Toggle>
      <Dropdown.Menu className="dropdown-econ-menu">
        {dropdownItem}
      </Dropdown.Menu>
    </Dropdown>
  )
}

export default TradePartnerDropdown